"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrCadSystemNameNamingRule = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const NetNamingRules_1 = require("../../../../NetCombobulation/NetNamingRules");
class OrCadSystemNameNamingRule {
    constructor() {
        this.type = NetNamingRules_1.NetNamingRuleType.Naming;
        this.assignedGroups = new Map();
    }
    apply(group, _hierarchy) {
        let bestId;
        let bestSuffix;
        let bestDepth = Infinity;
        for (const [instance, nets] of group.getNets()) {
            const depth = instance.path.length;
            for (const net of nets) {
                for (const wire of net.wires) {
                    const id = wire.strategyMetadata?.['system-id'];
                    if (!id) {
                        continue;
                    }
                    if (depth < bestDepth || (depth === bestDepth && (!bestId || sigma_engine_shared_1.Utils.naturalStringSort(id, bestId) < 0))) {
                        bestId = id;
                        bestDepth = depth;
                        bestSuffix = instance.sheetSymbol?.Name;
                    }
                }
            }
        }
        if (!bestId) {
            return undefined;
        }
        const fullName = bestSuffix ? `${bestId}_${bestSuffix}` : bestId;
        const entries = this.assignedGroups.get(bestId) ?? [];
        entries.push({ group, fullName });
        this.assignedGroups.set(bestId, entries);
        return fullName;
    }
    simplifyNonConflicting() {
        for (const [baseId, entries] of this.assignedGroups) {
            if (entries.length === 1 && entries[0].fullName !== baseId) {
                entries[0].group.physicalName = baseId;
            }
        }
    }
}
exports.OrCadSystemNameNamingRule = OrCadSystemNameNamingRule;
//# sourceMappingURL=OrcadSystemNameNamingRule.js.map